// extracted by mini-css-extract-plugin
module.exports = {"container":"WalletEvent_container__2dqpw","walletNumber":"WalletEvent_walletNumber__1fWNS","walletName":"WalletEvent_walletName__2mtXu"};